type CurrentUser = {
  isSuperUser?: boolean
}

type Transition = {
  to: () => { name?: string }
  router: { stateService: { target: (state: string) => any } }
}

// Blocks non-super-users from admin app routes. Waits for the current user to
// load so a page refresh on an admin route doesn't bounce a super user home.
export const resolveAdminAppTransition = (trans: Transition, getCurrentUser: () => Promise<CurrentUser | null>) => {
  const toState = trans.to().name
  if (!toState || !toState.startsWith('adminApp')) {
    return undefined
  }
  return getCurrentUser().then((user) => {
    if (!user || !user.isSuperUser) {
      return trans.router.stateService.target('root.home')
    }
    return true
  })
}
